import { BaseSiteService, CmsBannerComponent, OccConfig } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { forkJoin, Observable, of, Subject } from 'rxjs';
import { ContentService } from '../../spartacus/services/content.service';
import { SelectionModel } from '@angular/cdk/collections';
import { ChangeDetectorRef, Component, DestroyRef, inject, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { StartOrderService } from '../../custom-start-order/start-order.service';
import { Router } from '@angular/router';
import { UserInfoService } from '../../spartacus/services/user-info.service';
import { ReturnsUkService } from '../returns-uk.service';
import { Subscription } from 'rxjs';
import { shareReplay, take, takeUntil } from 'rxjs/operators';
import { ApiResponse,  ShipData,ReturnData,Product,GroupedProduct,GalleryImage, mobiledata } from '../location-data.model';
import { TemplateRef } from '@angular/core';
import { AfterViewInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgxFileDropEntry, FileSystemFileEntry, FileSystemDirectoryEntry } from 'ngx-file-drop';
import { GalleryItem, ImageItem } from 'ng-gallery';
import { HttpClient } from '@angular/common/http';
import { FileUploadModalComponent } from '../file-upload-modal/file-upload-modal.component';
import { ReturnsExitPopupComponent } from '../returns-exit-popup/returns-exit-popup.component';
import { Overlay, NoopScrollStrategy } from '@angular/cdk/overlay';
import { ApiFailureDialogService } from '../../api-failure-dialog/api-failure-dialog.service';
import { ReturnstremserviceService } from '../../spartacus/services/returnstremservice.service';
interface LocationData {
  locationId: string;
  totalCreditAqiv:string;
  totalCreditQivc:string;
  maxAqivQuantity: string;
  maxQivcQuantity: string;
  returnsProduct: ProductData[];
}

interface ProductData {
  batchNumber: string;
  selectedQuantity: number;
  totalQuantity: number;
  additionalQuantity: number;
  productName: string;
  poNumber: string;
}
@Component({
    selector: 'app-returns-additional',
    templateUrl: './returns-additional.component.html',
    styleUrls: ['./returns-additional.component.scss'],
    standalone: false
})
export class ReturnsAdditionalComponent {
  @ViewChild('fileUploadModal') fileUploadModal!: TemplateRef<any>;
  imageObject: Array<{ image: string, thumbImage: string }> = [];
  locationImages: { [key: string]: GalleryImage[] } = {}; // Store images by locationID
  images: { src: string, alt: string }[] = [];
  galleryImages: GalleryImage[] = [];
  selectedImage: GalleryImage | null = null;
  imageCount: number = 0;
  selectedIndex: number = 0;
  isVisible = false;
  locationId: any;
  adlReturnThanks:boolean = false;
  addtnlreturnSection:boolean = true;
  bannerNode: Observable<any> = this.component.data$;
  displayedColumns: string[] = ['locname', 'address', 'state','checked',];
  private subscription: Subscription | undefined;
  dataSource = new MatTableDataSource<LocationData>([]);
  returnsProductData: any;
  searchValue: string = '';
  selectedAddress: string | undefined;
  inputValueaQiv: string = '';
  inputValueQivc: string = '';
  formattedValue: string | null = '';
  formattedValueQivc: string | null = '';
  errMsg1:boolean = false;
  errMsg2:boolean = false;
  errMsg1qivc:boolean = false;
  errMsg2qivc:boolean = false;
  aqivMaxAllowedQty: any;
  qivcMaxAllowedQty: any;
  checkboxChecked: boolean = false; // Property to hold the checkbox state
  inputErrorMessage: string = ''; // Property to hold the input field error message
  checkboxErrorMessage: string = ''; 
  imgcheckboxChecked: boolean = false;
  imgcheckboxErrorMessage: string = ''; 
  selection = new SelectionModel<LocationData>(true, []);
  selectedRows: LocationData[] = [];
  selectedCount = 0;
  productsToReturn: any[] = [];
  uploadedImages: string[] = [];
  imageFiles: File[] = [];
  slideLeft: boolean = false;
  slideRight: boolean = false;
  locationImageFiles: { [key: string]: File[] } = {};
  errorMessages: { [key: string]: string } = {};
  checkboxStates: { [key: string]: boolean } = {};
  checkboxErrorMessages: { [key: string]: string } = {};
  showloader: boolean = false;
  showloader_return:boolean = true;
  showNewReturn: boolean = false;
  showProductReturn: boolean = false;
  showLocationSelection: boolean = true;
  aqivmaxquantity:number=0;
  qivcmaxquantity:number=0;
  additionalReturnData: any;
  maxDoseErrorMessage: string = '';
  batchDoseErrorMessages: { [batchNumber: string]: string } = {};
  productErrorMessage:string = '';
  defaultReturnSeason:string='';
  mobileuploaddata:mobiledata[]=[];
  showExitPopUp: boolean = false;
  private readonly destroy$ = new Subject<void>();
  
  constructor(protected config: OccConfig,private returnuploadservice:ReturnstremserviceService,private dialogservice:ApiFailureDialogService,private overlay: Overlay,public component: CmsComponentData<CmsBannerComponent>,private http: HttpClient,public dialog: MatDialog, private cdr: ChangeDetectorRef, private router: Router, private startOrderService: StartOrderService, private userInfoService: UserInfoService, public contentService:ContentService, private baseSiteService:BaseSiteService,private returnsUkService:ReturnsUkService) {
   
  }


  
 
  ngOnInit() {
    this.returnsUkService.additionalReturnData$.subscribe(
      data => {
        this.showloader = true;
    
        if (data && data.returnsOrderData) {
          this.additionalReturnData = data;
          this.locationId = data.returnsOrderData.locationId; // Store the locationId  
          this.aqivmaxquantity=Number(this.additionalReturnData.returnsOrderData.locations[0].maxAqivQuantity);
          this.qivcmaxquantity=Number(this.additionalReturnData.returnsOrderData.locations[0].maxQivcQuantity);
          data.returnsOrderData.locations.forEach((location: any) => {
            location['aqiverrorsor'] = false;
            location['qivcerrorsor'] = false;
            location['totalCreditAqiv'] = "";
            location['totalCreditQivc'] = "";
    
            location.returnsProduct.forEach((product: any) => {
              if (product.productName === 'aQIV' || product.productName === 'aTIV') {
                product['aqivbatcherror'] = false;
              } else {
                product['qivcbatcherror'] = false;
              }
    
              if (product.additionalQuantity === 0) {
                product.additionalQuantity = '';
              }
            });
          });
    
          this.showloader = false;
          this.cdr.detectChanges();
        } else {
          console.error('returnsOrderData is null or undefined');
          this.showloader = false;
          this.cdr.detectChanges();
        }
      },
      error => {
        console.error('Error fetching additional return data:', error);
        this.showloader = false;
        this.cdr.detectChanges();
      }
    );
    this.returnsUkService.getSeasons().pipe(shareReplay(1)).subscribe(response => {
      this.defaultReturnSeason = response.defaultReturnSeason;
    });
    this.userInfoService.getPopValue().pipe(takeUntil(this.destroy$)).subscribe((val: boolean) => {
      this.showExitPopUp = val;
      if(this.showExitPopUp){
        this.openExistpopup();
      }
      this.cdr.detectChanges();
    })
    
  }
 
  getImageurl(image: any): string {
    return this.config.backend?.occ?.baseUrl + image.url;
  }
  getmobileimage(token:string,locationid:string){

    this.userInfoService.mobilegetimage(token,locationid,this.additionalReturnData.season).subscribe(async response => {
      
      for(const image of response){
        image.url=this.getImageurl(image);
        //const eachimage: GalleryImage = { src: image.url, thumb: image.url, name: image?.realFileName };
        //this.returnsUkService.addImage(locationid,eachimage);
        const file= await this.returnsUkService.urlToFile(image.url,image.realFileName)
        const dataUrl = await this.readFileAsDataURL(file);

const newimage: GalleryImage = {
  src: dataUrl,
  thumb: dataUrl,
  name: file.name,
  mobileupload:true,
};

this.returnsUkService.addImage(locationid,newimage);
        if (!this.locationImages[locationid]) {
          this.locationImages[locationid] = [];
        }
        this.locationImages[locationid].push(newimage);
        this.returnsUkService.addImageFile(locationid,file);
  
      }
      this.returnsUkService.setmodalimage(locationid);
     this.userInfoService.mobiledeleteimage(token,locationid,this.additionalReturnData.season).subscribe({});
    });
  }
  
  private readFileAsDataURL(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
  
      reader.onload = (e: any) => resolve(e.target.result);
      reader.onerror = reject;
  
      reader.readAsDataURL(file);
    });
  }

  ngAfterViewInit(): void {
    this.returnuploadservice.imageUpload$.subscribe((res:any)=>{
      const uploadcheck = this.mobileuploaddata.find(c => c.qrtoken === res); 
      if(uploadcheck){
        const locationid=uploadcheck.location;
        const token=uploadcheck.token
        uploadcheck.streamup=false;
        this.getmobileimage(token,locationid)
      }
      
     

    })

    this.returnuploadservice.imageUploadfailure$.subscribe((res:any)=>{
      const uploadcheck = this.mobileuploaddata.find(c => c.qrtoken === res); 
      if(uploadcheck){
        const locationid=uploadcheck.location;
        const token=uploadcheck.token
        uploadcheck.streamup=false;

      }
      
     

    })
    
    this.returnsUkService.currentVisibility.subscribe(visibility => {
      this.isVisible = visibility === 'D';
      if(visibility !='A'){
        const body=<HTMLElement>document.querySelector("body");
        body.classList.remove("landingpage");
      }
      this.scrollTotop();
      this.showLoaderForThreeSeconds();
      this.cdr.detectChanges();
    });
    
    this.returnsUkService.getuploadmore().subscribe(res=>{
      const reuploadcheck = this.mobileuploaddata.find(c => c.location === res); 
      if(reuploadcheck && reuploadcheck.streamup==false){
        this.userInfoService.regeneratetoken(reuploadcheck.location).subscribe((response:any) => {
          reuploadcheck.qrtoken=response;
          reuploadcheck.streamup=true;
          this.userInfoService.mobiledeleteimage(reuploadcheck.token,reuploadcheck.location,this.additionalReturnData.season).subscribe({});

          this.returnuploadservice.connect(response);
       
           
              if ( this.additionalReturnData.returnsOrderData.locationId === reuploadcheck.location) { 
                this.additionalReturnData.returnsOrderData.qrToken = response; //update token
                const url=this.additionalReturnData.returnsOrderData.qrCodeScannerUrl;

                const parts = url.split('/'); parts[parts.length - 1] = response;
                const newUrl = parts.join('/');
                this.additionalReturnData.returnsOrderData.qrCodeScannerUrl=newUrl; // update qrToken url
              
                //this.modelfn(reuploadcheck.location,newUrl,response,reuploadcheck.streamup)
                const obj={
                  location:reuploadcheck.location,
                  url:newUrl,
                  qrtoken:response,
                  stream:reuploadcheck.streamup,
                  locationname:reuploadcheck.locationname

                }
this.returnsUkService.setnewqr(obj)
              }
              
               
  
        });
      }
    })
  }

  
  showLoaderForThreeSeconds() {
    this.showloader = true;
    setTimeout(() => {
      this.showloader = false;
      this.cdr.detectChanges();
    }, 1000);
  }
  
  scrollTotop(): void {
    // Call this method to scroll to the top
    this.contentService.scrollToTop();
  }

  
  getGroupedProductKeys(groupedProducts: { [key: string]: Product[] }): string[] {
    return Object.keys(groupedProducts);
  }
  formatNumber(value: string, product: Product, maxAllowedQty: number) {
    product.inputValueaQiv = value;
    const numericValue = value.replace(/\D/g, '');
    product.inputValueaQiv = numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  
    if (numericValue.length > 6) {
      product.formattedValue = '';
    } else {
      product.formattedValue = product.inputValueaQiv;
    }
  
    const numericQty = parseInt(numericValue, 10);
    if (numericQty > product.totalQuantity) {
      product.errMsg2 = true;
      product.errMsg1 = false;
    } else if (numericQty > maxAllowedQty) {
      product.errMsg1 = true;
      product.errMsg2 = false;
    } else {
      product.errMsg1 = false;
      product.errMsg2 = false;
    }
  }
  
  formatNumber1(value: string, product: Product, maxAllowedQty: number) {
    const numericValue = value.replace(/\D/g, '');
    product.inputValueQivc = numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  
    if (numericValue.length > 6) {
      product.formattedValueQivc = '';
    } else {
      product.formattedValueQivc = product.inputValueQivc;
    }
  
    const numericQty = parseInt(numericValue, 10);
    if (numericQty > product.totalQuantity) {
      product.errMsg2qivc = true;
      product.errMsg1qivc = false;
    } else if (numericQty > maxAllowedQty) {
      product.errMsg1qivc = true;
      product.errMsg2qivc = false;
    } else {
      product.errMsg1qivc = false;
      product.errMsg2qivc = false;
    }
  }
 
 
  
  
  restrictInput(event: KeyboardEvent) {
    const inputChar = String.fromCharCode(event.charCode);
    if (!/^\d+$/.test(inputChar)) {
      event.preventDefault();
    }
  }

  
 
  onCheckboxChange() {
    if (this.checkboxChecked) {
      this.checkboxErrorMessage = ''; // Clear the error message when checkbox is checked
    }
    else{
      this.checkboxErrorMessage = 'Please confirm to proceed';
    }
  }
  imgonCheckboxChange() {
    if (this.imgcheckboxChecked) {
      this.imgcheckboxErrorMessage = ''; // Clear the error message when checkbox is checked
    }
    else{
      this.imgcheckboxErrorMessage = 'Please either attach images or select the checkbox for manual inspection.';
    }
  }

  modelfn(locationID:string,url:string,qrtoken:string,stream:boolean,locname:string){
    if (!this.locationImages[locationID]) {
      this.locationImages[locationID] = [];
    }
    const dialogRef = this.dialog.open(FileUploadModalComponent, {
      scrollStrategy: this.overlay.scrollStrategies.noop(),
      width: '800px',
      data: { locationID, images: this.locationImages[locationID],url, season:this.additionalReturnData.season,qrtoken,stream,locname},
      disableClose: true,
      hasBackdrop: true,
      autoFocus: true,
      restoreFocus: true,
      backdropClass: 'custom-backdrop'
    });
  
    dialogRef.componentInstance.imagesUploaded.subscribe((data: { locationID: string, images: GalleryImage[], files: File[] }) => {
      this.locationImages[data.locationID] = data.images;
      this.locationImageFiles[data.locationID] = data.files;
      this.cdr.detectChanges(); // Trigger change detection
    });

    dialogRef.componentInstance.imageCountUpdated.subscribe((data: { locationID: string, count: number }) => {
      this.cdr.detectChanges(); // Trigger change detection
    });

    dialogRef.afterClosed().subscribe(result => {
    });
   
  }
   
    openFileUploadModal(locationID: string,url:string,qrtoken:string,token:string,locname:string): void {
   
      const uploadcheck = this.mobileuploaddata.find(c => c.location === locationID); 
      if (uploadcheck && uploadcheck.uploadclick === true && uploadcheck.streamup==false && this.getUploadedImageCount(locationID)==0 ) {
        this.userInfoService.regeneratetoken(locationID).subscribe((response:any) => {
          uploadcheck.qrtoken=response;
          qrtoken=response;
          uploadcheck.streamup=true;
          this.userInfoService.mobiledeleteimage(uploadcheck.token,uploadcheck.location,this.additionalReturnData.season).subscribe({});
          this.returnuploadservice.connect(response);
          const parts = url.split('/'); parts[parts.length - 1] = response;
          const newUrl = parts.join('/');
          this.modelfn(locationID,newUrl,response,uploadcheck.streamup,uploadcheck.locationname)
         
           
              if (this.additionalReturnData.returnsOrderData.locationId === locationID) { 
                this.additionalReturnData.returnsOrderData.qrToken = response; //update token
                this.additionalReturnData.returnsOrderData.qrCodeScannerUrl=newUrl; // update qrToken url
                 } 
               
               
  
        });
          
        }else if(uploadcheck && uploadcheck.uploadclick === true)
        {
          this.modelfn(locationID,url,qrtoken,uploadcheck.streamup,uploadcheck.locationname)
        }else{
          this.mobileuploaddata.push({ location: locationID,streamup:true, qrtoken: qrtoken ,uploadclick:true,token:token,locationname:locname});
          this.userInfoService.mobiledeleteimage(token,locationID,this.additionalReturnData.season).subscribe({});
          this.returnuploadservice.connect(qrtoken);
          this.modelfn(locationID,url,qrtoken,true,locname)
        } 
    }
  
  getUploadedImageCount(locationID: string): number {
    const count = this.locationImages[locationID] ? this.locationImages[locationID].length : 0;
    
    // Check if the count is more than 0 and update the checkbox state
    
    
  
    return count;

  }
  
  // Add properties to track the checkbox state and disabled state

  imgcheckboxDisabled: boolean = false;




  generatePayload(locationData: LocationData): any {
    let uploadvlaue;
    if(this.locationImages[this.locationId]){
    const locationmobileupload= this.locationImages[this.locationId].find(q => q.mobileupload === true);
    if(locationmobileupload){
      uploadvlaue=true
    }
    else{
      uploadvlaue=false
    }}else{
      uploadvlaue=false
    }
    return {
      locationId: this.locationId || '',
      totalCreditAqiv:locationData.totalCreditAqiv,
      totalCreditQivc:locationData.totalCreditQivc,
      qrScannerUsed:uploadvlaue,
      aqivMaxAllowedQuantity: locationData.maxAqivQuantity ? locationData.maxAqivQuantity.toString() : '',
      qivcMaxAllowedQuantity: locationData.maxQivcQuantity ? locationData.maxQivcQuantity.toString() : '',
      productsRefund: locationData.returnsProduct ? locationData.returnsProduct.map((product: ProductData) => ({
        batchNumber: product.batchNumber || '',
        initialQuantity: product.selectedQuantity ? product.selectedQuantity.toString() : '0',
        totalQuantity: product.totalQuantity ? product.totalQuantity.toString() : '0',
        additionalQuantity: product.additionalQuantity ? product.additionalQuantity.toString() : '0',
        productName: product.productName || '',
         poNumber: product.poNumber || ''
      })) : []
    };
  }
  

  getInitialQuantity(product: any): number {
    if (product.productName === 'aQIV' || product.productName === 'aTIV') {
      return product.inputValueaQiv ? product.inputValueaQiv.replace(/,/g, ""): 0;
    } else if (product.productName === 'QIVc' || product.productName === 'TIVc') {
      return product.inputValueQivc ? product.inputValueQivc.replace(/,/g, "") : 0;
    }
    return 0; // Default value if no input is provided
  }

  generateAllPayloads(response: any): any {
    const locationsData: LocationData[] = response.returnsOrderData.locations;
    return {
      season: response.season, // Replace with actual season value
      additionalReturnPresent: true,
      locations: locationsData.map(locationData => this.generatePayload(locationData))
    };
  }


  processAndSendPayloads(): void {
    if (!this.validateAll()) {
      return;
    }
  this.showloader = true; // Show loader
  
    // Use the API response data to generate the payload
    this.returnsUkService.additionalReturnData$.subscribe(data => {
      this.additionalReturnData = data;
      const payload = this.generateAllPayloads(this.additionalReturnData);
  
      // First, submit images
      this.submitImages().subscribe(
        () => {
          // After successful image upload, submit the payload
          this.returnsUkService.submitReturns(payload).subscribe(response => {

            if(response=='FAILURE' || response== 'failure' || response=='Failure' || response=='alreadyExist'){
              //this.returnsUkService.setReturnFailurePopup(true);
              if(localStorage.getItem('FailureDailog') != 'true'){
                this.dialogservice.openErrorDialog();
                localStorage.setItem('FailureDailog', 'true');
                this.userInfoService.setInPlaceOrder(false);
              }
              //this.adlReturnThanks = false;
              //this.addtnlreturnSection = false;
              this.showloader = false; // Hide loader
              this.scrollTotop();
              this.cdr.detectChanges();
            }else{
              this.userInfoService.setInPlaceOrder(false);
            this.adlReturnThanks = true;
            //To hide job bag code in returns thankyou page
            const bodyslot=document?.querySelector('.Section8-returnsLandingPage') as HTMLElement;
            bodyslot?.setAttribute("style","display:none");
            //To retuns banner in returns thankyou page
          /*   const bodyslot1=document?.querySelector('.Section3-returnsLandingPage') as HTMLElement;
            bodyslot1?.setAttribute("style","display:none"); */
            // To reduce space between top header alone in returns thankyou page  
        /*     const bodyslot2=document?.querySelector('.UkCreateReturn') as HTMLElement;
            bodyslot2?.setAttribute("style","margin-top:10px"); */
            //To reduce padding in pi banner in retun thankyou page
            /* const bodyslot3=document?.querySelector('.PibannerUk') as HTMLElement;
            bodyslot3?.setAttribute("style","padding: 10px 40px;");  */
            this.addtnlreturnSection = false;
            this.showloader = false; // Hide loader
            this.scrollTotop();
            this.cdr.detectChanges();
            }
          }, error => {
            console.error('Payload Submission Error:', error);
            this.showloader = false; // Hide loader
            //this.adlReturnThanks = false;
           // this.returnsUkService.setReturnFailurePopup(true);
           // this.addtnlreturnSection = false;
            this.scrollTotop();
            this.cdr.detectChanges();
          });
        },
        error => {
          console.error('Image Upload Error:', error);
          this.showloader = false; // Hide loader
           // this.adlReturnThanks = false;
           // this.returnsUkService.setReturnFailurePopup(true);
            //this.addtnlreturnSection = false;
            this.scrollTotop();
            this.cdr.detectChanges();
        }
      );
    });
  }
  
  submitImages(): Observable<any> {
    const uploadObservables = [];
   
    for (const locationID in this.locationImageFiles) {
      if (this.locationImageFiles.hasOwnProperty(locationID)) {
        const imageFormData = new FormData();
        imageFormData.append('locationsId', locationID);
        imageFormData.append('season', this.defaultReturnSeason);
        this.locationImageFiles[locationID].forEach((file: File, index: number) => {
          imageFormData.append('registration_uploadfile', file, file.name);
        });
        uploadObservables.push(this.returnsUkService.submitImages(imageFormData));
      }
    }
  
    // If there are no images to upload, return an observable that completes immediately
    if (uploadObservables.length === 0) {
      return of(null);
    }
  
    // Return an observable that completes when all image uploads are done
    return forkJoin(uploadObservables);
  }

getLocationsData(): any[] {
  return this.productsToReturn.map(returnData => returnData.returnsProductData.shipData).flat();
}

validateAll(): boolean {
  let isValid = true;
  this.errorMessages = {}; // Clear previous error messages
  this.checkboxErrorMessages = {}; // Clear previous error messages
  this.checkboxErrorMessage = ''; // Clear single checkbox error message
  this.productErrorMessage = ''; // Clear combined product error message

  for (const returnData of this.productsToReturn) {
    for (const shipData of returnData.returnsProductData.shipData) {
      let hasInput = false;
      for (const productName of this.getGroupedProductKeys(shipData.groupedProducts)) {
        if (productName === 'aQIV' || productName === 'aTIV' || productName === 'QIVc'|| productName === 'TIVc') {
          for (const product of shipData.groupedProducts[productName]) {
            if (product.inputValueaQiv || product.inputValueQivc) {
              hasInput = true;
              break;
            }
          }
        }
      }
      if (!hasInput) {
        this.errorMessages[shipData.locationID] = 'Please fill in at least one input field.';
        isValid = false;
      }

      const imageCount = this.getUploadedImageCount(shipData.locationID);
      if (imageCount === 0 && !this.checkboxStates[shipData.locationID]) {
        this.checkboxErrorMessages[shipData.locationID] = 'Please check the checkbox or upload an image.';
        isValid = false;
      }
    }
  }

  // Validate the single checkbox
  if (!this.checkboxChecked) {
    this.checkboxErrorMessage = 'Please confirm to proceed';
    isValid = false;
  }

  // Validate the single checkbox only if image count is 0
  if (this.getUploadedImageCount(this.additionalReturnData.returnsOrderData.locationId) === 0 && !this.imgcheckboxChecked) {
    this.imgcheckboxErrorMessage = 'Please either attach images or select the checkbox for manual inspection.';
    isValid = false;
  }

  // Validate aQIV and QIVc input fields
  const aqivProducts = this.additionalReturnData.returnsOrderData.locations[0].returnsProduct.filter((product: any) => (product.productName === 'aQIV' || product.productName === 'aTIV'));
  const qivcProducts = this.additionalReturnData.returnsOrderData.locations[0].returnsProduct.filter((product: any) => (product.productName === 'QIVc' || product.productName === 'TIVc'));

  const isAqivValid = aqivProducts.some((product: any) => product.additionalQuantity && product.additionalQuantity > 0);
  const isQivcValid = qivcProducts.some((product: any) => product.additionalQuantity && product.additionalQuantity > 0);

  if (!isAqivValid && !isQivcValid) {
    this.productErrorMessage = 'Please enter the doses to return';
    isValid = false;
  }
  if(this.aqivErrorMessage || this.qivcErrorMessage || this.additionalReturnData.returnsOrderData.locations[0].aqiverrorsor || this.additionalReturnData.returnsOrderData.locations[0].qivcerrorsor){
    isValid = false;
  }

  this.cdr.detectChanges(); // Trigger change detection
  return isValid;
}

dynImageCheckboxChecked: boolean = false;
dynImageCheckboxErrorMessage: string = '';
aqivErrorMessage: string = '';
qivcErrorMessage: string = '';

updateTotals(product:any): void {
  if (this.additionalReturnData && this.additionalReturnData.returnsOrderData) {
    let totalAqivQuantity = 0;
    let totalQivcQuantity = 0;
    //let aqivBatchErrorMessage = '';
    //let qivcBatchErrorMessage = '';

   // this.additionalReturnData.returnsOrderData.locations[0].returnsProduct.forEach((product: any) => {
      product.totalDosesReturned = this.calculateTotalDosesReturned(product);

      if (product.productName === 'aQIV' || product.productName === 'aTIV') {
        totalAqivQuantity += Number(product.totalDosesReturned);
        const additionalQuantity = Number(product.additionalQuantity)
        // Check if total doses returned for each batch number exceeds totalQuantity
        if ( Number(product.additionalQuantity) > Number(product.totalQuantity)) {
         // aqivBatchErrorMessage = 'You have exceeded the number of doses in this batch. Please correct.';
         product.aqivbatcherror=true
        }else{
          product.aqivbatcherror=false
        }
        // Check if total aQIV quantity exceeds maxAqivQuantity
        
      } else if (product.productName === 'QIVc' || product.productName === 'TIVc') {
        totalQivcQuantity += Number(product.totalDosesReturned);
        const additionalQuantity = Number(product.additionalQuantity)
        // Check if total doses returned for each batch number exceeds totalQuantity
        if ( Number(product.additionalQuantity) > Number(product.totalQuantity)) {
         // qivcBatchErrorMessage = 'You have exceeded the number of doses in this batch. Please correct.';
         product.qivcbatcherror=true
        }
        // Check if total QIVc quantity exceeds maxQivcQuantity
        else {
          product.qivcbatcherror=false
        }
      }
   // });
     // Clear the combined error message if any valid input is detected
     const isAqivValid = this.additionalReturnData.returnsOrderData.locations[0].returnsProduct.some((product: any) => (product.productName === 'aQIV' || product.productName === 'aTIV') && product.additionalQuantity && product.additionalQuantity > 0);
     const isQivcValid = this.additionalReturnData.returnsOrderData.locations[0].returnsProduct.some((product: any) => (product.productName === 'QIVc' || product.productName === 'TIVc') && product.additionalQuantity && product.additionalQuantity > 0);
 
     if (isAqivValid || isQivcValid) {
       this.productErrorMessage = '';
     }
    this.cdr.detectChanges();
  }
  
}
///error here
isQivcQuantityZero(): boolean {
  return this.additionalReturnData.returnsOrderData.locations[0].maxQivcQuantity === "0";
}

ismaxAqivQuantityZero(): boolean {
  return this.additionalReturnData.returnsOrderData.locations[0].maxAqivQuantity === "0";
}


calculateTotalDosesReturned(product: any): number {
  const selectedQuantity = Number(product.selectedQuantity) || 0;
  const additionalQuantity = Number(product.additionalQuantity) || 0;
  return selectedQuantity + additionalQuantity;
}

calculateTotalSelectedDoses(productName: string): number {
  return this.additionalReturnData.returnsOrderData.locations[0].returnsProduct
    .filter((product: any) => product.productName === productName)
    .reduce((sum: number, product: any) => sum + (Number(product.selectedQuantity) || 0), 0);
}
calculateTotalcreditprev(productName: string) : number{
  
  
  let sumprev=this.calculateTotalSelectedDoses(productName);
  if(productName === 'aQIV' || productName === 'aTIV'){
    if(Number(this.additionalReturnData.returnsOrderData.locations[0].maxAqivQuantity)>=0){
      
      return sumprev;
    }else{
      const newprev= sumprev+Number(this.additionalReturnData.returnsOrderData.locations[0].maxAqivQuantity)
      return newprev
    }

  }else if(productName === 'TIVc' || productName === 'QIVc'){
    if(Number(this.additionalReturnData.returnsOrderData.locations[0].maxQivcQuantity)>=0){
      
      return sumprev;
    }else{
      const newprev= sumprev+Number(this.additionalReturnData.returnsOrderData.locations[0].maxQivcQuantity)
      return newprev
    }

  }else{
    return sumprev
  }
      
}
calculateTotalAdditionalDoses(productName: string): number {
  let totaladditional=
   this.additionalReturnData.returnsOrderData.locations[0].returnsProduct
    .filter((product: any) => product.productName === productName)
    .reduce((sum: number, product: any) => sum + (Number(product.additionalQuantity) || 0), 0);

    if(productName=='aQIV' || productName=='aTIV'){
       if(Number(totaladditional) > Number(this.additionalReturnData.returnsOrderData.locations[0].totalQuantity)){
        this.additionalReturnData.returnsOrderData.locations[0].aqiverrorsor=true;
       }else{
        this.additionalReturnData.returnsOrderData.locations[0].aqiverrorsor=false;
       }

     
    }else{
      if(Number(totaladditional) > Number(this.additionalReturnData.returnsOrderData.locations[0].totalQuantity)){
        this.additionalReturnData.returnsOrderData.locations[0].qivcerrorsor=true;
       }else{
        this.additionalReturnData.returnsOrderData.locations[0].qivcerrorsor=false;
       }
    }
    
    if(productName=='aQIV'|| productName=='aTIV'){
      if( this.additionalReturnData.returnsOrderData.locations[0].returnsProduct.find((check: any) => {
        return check.aqivbatcherror == true;
      }) ){
        this.aqivErrorMessage=' You are claiming more doses than received for this batch.'
      }else{
        this.aqivErrorMessage=''
      }
    }else{
      if( this.additionalReturnData.returnsOrderData.locations[0].returnsProduct.find((check: any) => {
        return check.qivcbatcherror == true;
      }) ){
        this.qivcErrorMessage=' You are claiming more doses than received for this batch.'
      }else{
        this.qivcErrorMessage=''
      }

    }
    
    return totaladditional
}

calculateTotalDoses(productName: string): number {
  return this.calculateTotalSelectedDoses(productName) + this.calculateTotalAdditionalDoses(productName);
}


getTotalDosesForCredit(productName: string): number {
  if (!this.additionalReturnData || !this.additionalReturnData.returnsOrderData) {
    return 0;
  }

  const loc = this.additionalReturnData.returnsOrderData.locations?.[0];
  if (!loc) {
    return 0;
  }

  const sumAdditional = this.calculateTotalAdditionalDoses(productName);

  // if user hasn't entered any additional doses, show 0
  if (!sumAdditional || sumAdditional <= 0) {
    return 0;
  }

  const eligible = Number((productName === 'aQIV' || productName === 'aTIV') ? loc.maxAqivQuantity : loc.maxQivcQuantity) || 0;
  const min =Math.min(sumAdditional, eligible)
  // show the user-entered additional sum, capped at eligible
  if(productName === 'aQIV' || productName === 'aTIV'){
    this.additionalReturnData.returnsOrderData.locations[0].totalCreditAqiv=min==0?'':min.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
   // this.additionalReturnData.returnsOrderData.locations?[0].totalCreditAqiv=" sdsd"
  }else{
    this.additionalReturnData.returnsOrderData.locations[0].totalCreditQivc=min==0?'':min.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  }
  return Math.min(sumAdditional, eligible);
}
getCreditTotal(productName: string): number {
  return this.calculateTotalcreditprev(productName) + this.getTotalDosesForCredit(productName);
}
hasProduct(productName: string): boolean {
  return this.additionalReturnData.returnsOrderData.locations[0].returnsProduct.some((product: any) => product.productName === productName);
}

openExistpopup(): void {

  const dialogRef = this.dialog.open(ReturnsExitPopupComponent, {
    scrollStrategy: this.overlay.scrollStrategies.noop(),
    width: '700px',
    disableClose: false,
    hasBackdrop: true,
    autoFocus: true,
    restoreFocus: true,
    backdropClass: 'custom-backdrop',
    data: {
      fromReturns: this.showExitPopUp ? false : true
    }
  });
  
}
goToreturn(): void {
  window.location.reload();
}
ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
 
}
